var _path;
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
class IconCheckMarkSolid extends Component {
  constructor() {
    super(...arguments);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
      name: "IconCheckMark",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef
    }), _path || (_path = /*#__PURE__*/React.createElement("path", {
      d: "M1743.858 267.012 710.747 1300.124 176.005 765.382 0 941.387l710.747 710.871 1209.24-1209.116z",
      fillRule: "evenodd"
    })));
  }
}
IconCheckMarkSolid.glyphName = 'check-mark';
IconCheckMarkSolid.variant = 'Solid';
IconCheckMarkSolid.displayName = 'IconCheckMarkSolid';
IconCheckMarkSolid.propTypes = {
  ...SVGIcon.propTypes
};
IconCheckMarkSolid.allowedProps = [...SVGIcon.allowedProps];
export default IconCheckMarkSolid;
export { IconCheckMarkSolid };